import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import { environment as config } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../modules/auth/auth.service';

@Injectable()
export class BasicService {
  constructor(protected authService: AuthService, protected translate: TranslateService) {}

  private getBody(res: Response) {
    try {
      return res.json();
    } catch (err) {
      return res.text();
    }
  }

  protected extractData(
    res: Response,
    notify: boolean,
    messages: { success?: string; failed?: string } = {}
  ) {
    const body = this.getBody(res);
    if (!notify) {
      return body;
    }
    if (!body || !res.ok) {
      toastr.error(this.translate.instant(messages.failed || 'action.failed'));
    } else {
      toastr.success(this.translate.instant(messages.success || 'action.success'));
    }
    return body;
  }

  protected handleError(error: any) {
    console.error(error);
    toastr.error(this.translate.instant('action.failed'));
    const defaultError = 'Yikes! There was a problem with our server';
    if (error && error._body) {
      let errorJson;
      try {
        errorJson = JSON.parse(error._body);
      } catch (err) {
        errorJson = { err, message: defaultError };
      }
      if (error.status === 401) {
        this.authService.logout();
        return Observable.of(true);
      }
      return Observable.throw((errorJson || {}).message);
    }
    return Observable.throw(defaultError);
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/basic.ts